(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-editorial-recommendations"]) return;
  try {
    
(function () {
  document.querySelectorAll('.sr-pdp-nav-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var sliderId = btn.getAttribute('data-slider');
      var slider = document.getElementById(sliderId);
      if (!slider) return;
      var slide = slider.querySelector('.sr-pdp-slide');
      if (!slide) return;
      var slideWidth = slide.offsetWidth + 24;
      if (btn.classList.contains('sr-pdp-prev')) {
        slider.scrollBy({ left: -slideWidth, behavior: 'smooth' });
      } else {
        slider.scrollBy({ left: slideWidth, behavior: 'smooth' });
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
